import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { BodyContainer, CashBox, DTtitle } from "../bank/styles";
import { Header, HeaderBtn, HeaderTitle } from "../bank/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PaymentsIcon from "@mui/icons-material/Payments";
import AddCash from "./AddCash";
import Loader from "../../components/components/Loader";
import DataTable from "react-data-table-component";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Repo from "../../Repository/Repo";
import AddDeposit from "./AddDeposit";
import moment from "moment/moment";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

function CashInHand() {
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [records, setRecords] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [remModal, setRemModal] = useState(false);
  const [bank, setBank] = useState("");
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  console.log('records', records);
  console.log('bank', bank);
  const companyCode = localStorage.getItem("companyCode")


useEffect(()=>{
  getBank();
},[records])
  const columns = [
    {
      name: "Description",
      selector: (row) => row?.bankName,
    },

    {
      name: "Date",
      selector: (row) => moment(row?.date).format("DD-MM-YYYY"),
    },
    {
      name: "Balance",
      selector: (row) => row?.balance,
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <Stack direction="row" alignItems="center" spacing="16px">
            <BorderColorIcon
              sx={{ color: "#4eaf51" }}
              onClick={() => handleEdit(row)}
            />
               {companyCode !== "4890" && (
            <DeleteForeverIcon
            sx={{ color: "#D35353" }}
            onClick={() => handleEdit(row, "remove")}
          />
          )}
           
          </Stack>
        );
      },
    },
  ];

  const getBank = async () => {
    try {
      let { data } = await Repo.banks({
        request: {
          method: "getCashInHandBankByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      console.log('dataaaa', data)
      if (data.response.data.bank) {
        setBank(data.response.data.bank);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  const toggle = () => {
    setAddModal((prev) => !prev);
  };

  const onSuccess = (e) => {

    // toggle();
    console.log('cakeeed');
    // getBankDetails();
    getBank();


  };

  const remToggle = () => {
    setRemModal((prev) => !prev);
  };

  const depToggle = () => {
    setModal((prev) => !prev);
  };


  const handleRow = (row) => {
    history.push({
      pathname: "/inventory/admin/cashInHand-details",
      state: { bank: row },
    });
  };

  const handleEdit = (row, type = null) => {
    setSelectedRow(row);
    if (type == "remove") {
      remToggle();
    } else {
      toggle();
    }
  };

  const handleUpdate = (e) => {
    toggle();
    let copy = JSON.parse(JSON.stringify(records));

    let found = copy.find((i) => i.amount == e.amount);
    if (found) {
      found.amount = e.amount;
      found.date = e.date;
      found.description = e.description;
    }
    setRecords(copy);
  };

  const handleAdd = () => {
    depToggle();
    getBank();
    getBankDetails();
  };

  return (
    <Box>
      <Header sx={{ py: "4px", flexDirection: { xs: "column", md: "row" } }}>
        <Stack direction="row" spacing="16px">
          <HeaderBtn onClick={toggle}>
            <AddCircleOutlineIcon sx={{ mr: "8px" }} /> Add Cash
          </HeaderBtn>

          <HeaderBtn onClick={() => depToggle("check")}>
            <AccountBalanceIcon sx={{ mr: "8px" }} />
            Bank Transfer
          </HeaderBtn>
        </Stack>
        <HeaderTitle sx={{ fontSize: "18px !important" }}>
          Cash in hand
        </HeaderTitle>
        <CashBox>
          <Stack>
            <Typography>Current cash balance</Typography>
            <Typography sx={{ color: "#4EAF51" }}>
              Rs : {bank.balance || 0}
            </Typography>
          </Stack>
          <PaymentsIcon sx={{ color: "#767676" }} />
        </CashBox>
      </Header>
      <BodyContainer>
 
          <DataTable
            title={<DTtitle>Transaction details</DTtitle>}
            columns={columns}
            data={[bank]}
            highlightOnHover={true}
            pointerOnHover={true}
            Clicked
            onRowClicked={(row) => handleRow(row)}
          />
           {loading && <Loader loading={true} />}
      </BodyContainer>

      {addModal && <AddCash onClose={toggle} onSuccess={onSuccess} bank={bank}/>}
      {modal && (
        <AddDeposit onClose={depToggle} onSuccess={handleAdd}  bank={bank}/>
      )}
    </Box>
  );
}

export default CashInHand;
